import {mapGetters, mapMutations} from "vuex";
import _ from 'lodash';

export default {
    name: "IndexTableFilter",

    props: {
        slug: {
            type: String,
            required: true,
        }
    },
    data: () => ({
        filterValue: ''
    }),

    computed: {
        ...mapGetters('indexTable', {
            filter: 'getFilter',
        })
    },
    methods: {
        ...mapMutations('indexTable', {
            setFilter: 'setFilter',
        })
    },
    watch: {
        filterValue: _.debounce(function () {
            this.setFilter({column: this.slug, value: this.filterValue});
        }, 600)
    }
}